import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { commonLocale } from "./common";
var locale = _objectSpread(_objectSpread({}, commonLocale), {}, {
  locale: 'si_LK',
  today: 'අද',
  now: 'දැන්',
  backToToday: 'අදට ආපසු',
  ok: 'හරි',
  clear: 'හිස් කරන්න',
  week: 'සතිය',
  month: 'මාසය',
  year: 'අවුරුද්ද',
  timeSelect: 'වේලාවක් තෝරන්න',
  dateSelect: 'දිනයක් තෝරන්න',
  weekSelect: 'සතියක් තෝරන්න',
  monthSelect: 'මාසයක් තෝරන්න',
  yearSelect: 'අවුරුද්දක් තෝරන්න',
  decadeSelect: 'දශකයක් තෝරන්න',
  dateFormat: 'YYYY/M/D',
  dateTimeFormat: 'YYYY/M/D HH:mm:ss',
  monthBeforeYear: false,
  previousMonth: 'කලින් මාසය (පිටුව ඉහළට)',
  nextMonth: 'ඊළඟ මාසය (පිටුව පහළට)',
  previousYear: 'පසුගිය අවුරුද්ද (Control + වම)',
  nextYear: 'ඊළඟ අවුරුද්ද (Control + දකුණ)',
  previousDecade: 'පසුගිය දශකය',
  nextDecade: 'ඊළඟ දශකය',
  previousCentury: 'පසුගිය සියවස',
  nextCentury: 'ඊළඟ සියවස'
});
export default locale;